'use strict';

var lodashDebounce = require('lodash/function/debounce');

var appDom = require('./app-dom');

var locationCss;
var data;

var setupLocationCss = function() {

	locationCss = {
		'top': {
			top: 0,
			left: 0,
			right: 'auto',
			bottom: 'auto'
		},
		'bottom': {
			bottom: 0,
			left: 0,
			top: 'auto',
			right: 'auto'
		},
		'top-left': {
			top: data.padding,
			left: data.padding,
			right: 'auto',
			bottom: 'auto'
		},
		'top-center': {
			top: data.padding,
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			transform: 'translateX(-50%)'
		},
		'top-right': {
			top: data.padding,
			right: data.padding,
			left: 'auto',
			bottom: 'auto'
		},
		'center-left': {
			top: '50%',
			left: data.padding,
			right: 'auto',
			bottom: 'auto',
			transform: 'translateY(-50%)'
		},
		'center': {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			transform: 'translate(-50%, -50%)'
		},
		'center-right': {
			top: '50%',
			right: data.padding,
			left: 'auto',
			bottom: 'auto',
			transform: 'translateY(-50%)'
		},
		'bottom-left': {
			bottom: data.padding,
			left: data.padding,
			top: 'auto',
			right: 'auto'
		},
		'bottom-center': {
			bottom: data.padding,
			left: '50%',
			top: 'auto',
			right: 'auto',
			transform: 'translateX(-50%)'
		},
		'bottom-right': {
			bottom: data.padding,
			right: data.padding,
			top: 'auto',
			left: 'auto'
		}
	};

};

var sizeIframeToContent = function() {

	var css = locationCss[data.location];
	var contentRect;

	// Hide the iframe and make it fill the window so we can measure the size of the content as if it had the entire window
	appDom.iframe.css({
		transition: 'none',
		opacity: 0,
		top: 0,
		left: 0,
		right: 'auto',
		bottom: 'auto',
		width: '100%',
		height: '100%',
		'max-width': 'none',
		'max-height': 'none',
		transform: 'none'
	});

	contentRect = appDom.promoLayout[0].getBoundingClientRect();

	appDom.iframe.css({
		width: Math.ceil(contentRect.width),
		height: Math.ceil(contentRect.height)
	});

	if (data.applyBoxShadow) {

		css['max-width'] = 'calc(100% - ' + data.padding * 2 + 'px)';
		css['max-height'] = 'calc(100% - ' + data.padding * 2 + 'px)';
		css['box-shadow'] = '0 0 20px 0 rgba(0,0,0,.5)';

	}

	if (appDom.iframe.hasClass('promo--is-active')) {

		css.opacity = 1;

	}

	appDom.iframe.css(css);

};

var setSize = function() {

	if (appDom.topWindow.width() < 768) {

		appDom.promo
			.removeClass('promo--medium')
			.addClass('promo--small');

	} else {

		appDom.promo
			.removeClass('promo--small')
			.addClass('promo--medium');
	}

};

/*var observeMutations = function() {

	var observer = new MutationObserver(function(mutationsList) {

		var layoutMutation = false;

		console.log('MUTATION TO PROMO OBSERVED!');

		mutationsList.forEach(function(mutation) {

			// Ignore notify message mutations as those do not change the layout

			mutation.addedNodes.forEach(function(node) {

				console.log('node added', node);

				if (!node.classList.contains('notify-container')) {

					layoutMutation = true;

				}

			});

			mutation.removedNodes.forEach(function(node) {

				console.log('node removed', node);

				if (!node.classList.contains('notify-container')) {

					layoutMutation = true;

				}

			});

		});

		if (layoutMutation) {

			console.log('calling sizeIframeToContent()...');
			sizeIframeToContent();

		}

	});

	observer.observe(appDom.promo[0], {
		childList: true,
		subtree: true
	});

};*/

var observeMutations = function() {

	appDom.promo.on('promo-form-mutation', sizeIframeToContent);

};

var onPromoClosed = function() {

	appDom.topWindow.off('resize.promo-' + data.id);

};

var onTopWindowResize = function() {

	setSize();

	if (!data.overlay) {

		sizeIframeToContent();

	}

};

var onWindowLoad = function() {

	setSize();

	if (!data.overlay) {

		setupLocationCss();
		observeMutations();
		// Make the iframe size match it's content size, as we want to be able to interact with the main content below
		sizeIframeToContent();

	}

	appDom.topWindow.on('resize.promo-' + data.id, lodashDebounce(onTopWindowResize, 150));

};

var init = function(d) {

	data = d;
	setSize();
	appDom.window.on('load', onWindowLoad);
	appDom.promo.on('promo-closed', onPromoClosed);

};

module.exports = {
	init: init
};
